"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExactLength = void 0;
const class_validator_1 = require("class-validator");
const combineDecorators_1 = require("../utils/combineDecorators");
/**
 * Applies an exact length by combining MinLength and MaxLength.
 */
const ExactLength = (length) => (0, combineDecorators_1.combineDecorators)((0, class_validator_1.MinLength)(length), (0, class_validator_1.MaxLength)(length));
exports.ExactLength = ExactLength;
